import React from "react";

const STYLE = { PRIME: "#0B4DA2", "5 Star": "#1F4E9C", "4 Star": "#3F74B8", "3 Star": "#6B7280", "2 Star": "#D61F3C", "1 Star": "#D61F3C" };

export function PrimeLevel({ level, className = "" }) {
  if (!level) return <span className="text-slate-400">Not recorded</span>;
  if (level === "PRIME") return <span className={`font-semibold ${className}`} style={{ color: STYLE.PRIME }}>Prime</span>;
  const n = Number(level[0]);
  return <span className={`tracking-tight ${className}`} style={{ color: STYLE[level] }} aria-label={level} title={level}>{"★".repeat(n)}</span>;
}

export async function openGuidelines(api, toast, apiError) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.post("/prime/guidelines/link");
    const url = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}${data.url}`;
    if (w) { w.opener = null; w.location.href = url; } else window.location.assign(url);
  } catch (e) { if (w) w.close(); toast.error(apiError(e)); }
}
